<template>
  <div class="bind-teacher">
    <el-dialog :title="'绑定教师(职务：' + jobItemData.jobName + ')'" :visible="bindShow" width="1200px" @close="dialogClose"
      @open="dialogOpen">
      <!-- <el-form :inline="true">
        <el-form-item label="职务名称" label-width="100px">
          <el-input v-model="jobItemData.jobName" autocomplete="off" placeholder="请输入职务名称" style="width: 235px"
            :disabled="true"></el-input>
        </el-form-item>
      </el-form> -->
      <div class="table-list">
        <div class="table-item">
          <el-form @submit.native.prevent>
            <el-form-item label="教师搜索" label-width="80px">
              <div class="notice-search">
                <search :placeholder="placeholder" @search="search" />
              </div>
            </el-form-item>
          </el-form>
          <div>未绑定教师：</div>
          <el-table ref="table" :data="teacherList" style="width: 100%" height="350px">
            <!-- <el-table-column type="selection" width="55"></el-table-column> -->
            <el-table-column prop="teacherName" label="姓名"> </el-table-column>
            <el-table-column prop="teacherNumber" label="工号"> </el-table-column>
            <el-table-column prop="phone" label="手机号"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <div class="handle-container">
                  <!-- 添加 -->
                  <el-button v-if="!scope.row.isBound" type="success" @click="handleAddSelection(scope.row)"
                    v-hasPermi="'sc:teachersjob:edit'" size="mini">添加</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table-item">
          <el-form @submit.native.prevent>
            <el-form-item label="教师搜索" label-width="80px">
              <div class="notice-search">
                <search :placeholder="placeholder" @search="previousSearch" />
              </div>
            </el-form-item>
          </el-form>
          <div>已绑定教师：{{ previousSelectList.length }} 名</div>
          <el-table ref="bindTable" :data="previousSelectList" style="width: 100%" height="350px">
            <el-table-column prop="teacherName" label="姓名"> </el-table-column>
            <el-table-column prop="teacherNumber" label="工号"> </el-table-column>
            <el-table-column prop="phone" label="手机号"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <div class="handle-container">
                  <!-- 删除 -->
                  <el-button type="danger" @click="deleteTeachersJob(scope.row)" v-hasPermi="'sc:teachersjob:edit'"
                    size="mini">移除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="form-btn">
        <el-button type="primary" @click="clearBond" v-hasPermi="'sc:teachersjob:clear'">清空绑定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";
export default {
  name: "",
  props: ["bindShow", "jobItemData"],
  data() {
    return {
      selectList: [],
      previousSelectList: [],
      placeholder: "请输入教师姓名",
      teacherName: "",
      noBindTeacherName: "",
      teacherList: [],
      indexArray: [],
      isInitialSelection: true,
      filteredTeacherList: []
    };
  },
  components: {
    search,
  },
  created() {
    this.getTeachersNoJobList();
    this.getTeachersJobList();
  },
  methods: {
    // 删除单个教师职务绑定
    deleteTeachersJob(row) {
      let data = {
        "jobId": this.jobItemData.id,
        "teacherId": row.id
      };
      this.isInitialSelection = true;
      this.delete(this.$url.deleteTeachersJob, data).then((res) => {
        if (res.code == 200) {
          this.$message.success("删除成功");
          // this.previousSelectList = [];
          this.getTeachersNoJobList();
          this.getTeachersJobList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 清空职务绑定
    clearBond() {
      this.$confirm('是否清空职务绑定?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          jobId: this.jobItemData.id,
        };
        this.$emit("delSubmit", data);
        // this.isInitialSelection = true;
        // this.$refs.table.clearSelection();
        // this.selectList = [];
        this.previousSelectList = [];
        // setTimeout(() => {
        //   this.isInitialSelection = false;
        // }, 500)
      }).catch(() => {

      });
    },
    // 查询职务绑定教师列表
    // getTeachersJobList() {
    //   this.get(this.$url.getTeachersJobList + "?jobId=" + this.jobItemData.id).then(
    //     (res) => {
    //       // console.log("查询当前职务绑定教师列表==>", res);

    //       // 复制已选中的教师列表到previousSelectList中，用于增加和删除绑定判断
    //       res.data.forEach(id => {
    //         // 使用 find 方法在 this.teacherList 数组中查找 id 匹配的对象
    //         const teacher = this.teacherList.find(t => t.id === id);
    //         // 如果找到匹配的对象，则将其添加到 bindTeacherList
    //         if (teacher && !this.previousSelectList.some(existingTeacher => existingTeacher.id === teacher.id)) {
    //           this.previousSelectList.push(teacher);
    //         }
    //       });

    //       // 将返回的分组成员转换，然后将对应的教师列表切换为选中状态
    //       // this.indexArray = res.data
    //       //   .map((obj) => this.teacherList.findIndex((item) => item.id === obj))
    //       //   .filter((index) => index !== -1);

    //       // this.indexArray.forEach((index) => {
    //       //   if (index !== -1) {
    //       //     this.$refs.table.toggleRowSelection(this.teacherList[index], true);
    //       //   }
    //       // });

    //       // // 将初始台设置为false，以便后续切换复选框时可以正常调用接口
    //       // setTimeout(() => {
    //       //   this.isInitialSelection = false;
    //       // }, 1000)
    //     }
    //   );
    // },
    getTeachersJobList() {
      this.get(this.$url.getTeachersJobList, {
        jobId: this.jobItemData.id,
        teacherName: this.teacherName,
      }).then(
        (res) => {
          // if (!res.data || !Array.isArray(res.data)) return;
          this.previousSelectList = res.data;

          // // 使用 Set 提高查找效率
          // const boundTeacherIds = new Set(res.data);

          // // 遍历 teacherList，更新 isBound 状态
          // this.teacherList.forEach(teacher => {
          //   teacher.isBound = boundTeacherIds.has(teacher.id);
          // });

          // // 可选：同步 previousSelectList（用于 UI 显示）
          // this.previousSelectList = this.teacherList.filter(teacher => teacher.isBound);
        }
      );
    },
    getTeachersNoJobList() {
      this.get(this.$url.getTeachersNoJobList, {
        jobId: this.jobItemData.id,
        teacherName: this.noBindTeacherName,
      })
        .then((res) => {
          // console.log("获取教师==>", res);
          // 初始化教师列表，并添加 isBound 状态
          this.teacherList = res.data;
          // if (!this.teacherList || !this.teacherList.length) return;
          // this.getTeachersJobList();
        })
        .catch((err) => {
          console.log("获取教师列表err==>", err);
        });
    },
    previousSearch(query) {
      this.teacherName = query;
      this.getTeachersJobList();
    },
    search(query) {
      this.noBindTeacherName = query;
      this.getTeachersNoJobList();

      // 重置选中状态
      // this.selectList = [];
      // this.previousSelectList = [];
      // this.isInitialSelection = true;

      // 清除所有选中状态
      // this.$refs.table.clearSelection();
    },
    // handleSelectionChange(val) {
    //   this.selectList = val;

    //   // 检查是否是刚打开页面的初始选中
    //   if (!this.isInitialSelection) {
    //     // 计算新增和减少的项
    //     const addedItems = this.selectList.filter(item => !this.previousSelectList.some(prevItem => prevItem.id === item.id));
    //     const removedItems = this.previousSelectList.filter(prevItem => !this.selectList.some(item => item.id === prevItem.id));

    //     // 调用不同的接口
    //     if (addedItems.length > 0) {
    //       this.handleAddSelection(addedItems);
    //     }
    //     if (removedItems.length > 0) {
    //       this.handleRemoveSelection(removedItems);
    //     }

    //     // 更新上一次的选中状态
    //     this.previousSelectList = [...this.selectList];
    //   }
    // },
    handleAddSelection(addedItem) {
      // 处理新增选中项的逻辑
      // console.log('新增选中项:', addedItems);
      // 调用新增选中项的接口
      this.post(this.$url.insertTeachersJob, {
        jobId: this.jobItemData.id,
        teacherId: addedItem.id,
      }).then((res) => {
        if (res.code == 200) {
          this.$message.success("绑定成功");
          this.getTeachersNoJobList();
          this.getTeachersJobList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // handleRemoveSelection(removedItems) {
    //   // 处理取消选中项的逻辑
    //   // console.log('取消选中项:', removedItems);
    //   // 调用取消选中项的接口
    //   this.delete(this.$url.deleteTeachersJob, {
    //     jobId: this.jobItemData.id,
    //     teacherId: removedItems[0].id,
    //   }).then((res) => {
    //     if (res.code == 200) {
    //       this.$message.success("删除成功");
    //       this.getTeachersJobList();
    //     } else {
    //       this.$message.error(res.msg);
    //     }
    //   });
    // },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:bindShow", false);
    },
    dialogOpen() { },
  },
};
</script>

<style lang="scss" scoped>
@import "./bind-teacher.scss";
</style>
